import { createAction } from 'redux-actions';
import { createBoundAction } from './actions.js';

const routineStages = ['REQUESTED', 'PENDING', 'FULFILLED', 'REJECTED', 'CANCELLED'];

export function createCustomRoutine(typePrefix, createAction, params = []) {
  const createActionCreator = (type) => createAction(`${typePrefix}_${type}`, ...params);

  const routine = routineStages.reduce((result, stage) => {
    const actionCreator = createActionCreator(stage);
    return Object.assign(result, {
      [stage.toLowerCase()]: actionCreator,
      [stage.toUpperCase()]: actionCreator.toString()
    });
  }, createActionCreator(routineStages[0]));

  routine.PREFIX = typePrefix;

  return routine;
}

export function createRoutine(typePrefix, ...params) {
  return createCustomRoutine(typePrefix, createAction, params);
}

export function createBoundRoutine(typePrefix) {
  return createCustomRoutine(typePrefix, (type) => createBoundAction(type)());
}
